import Vue from 'vue';

// local state
const getDefaultState = () => {
	return {
		systemSelection: {
			pipe_system: 1,
			pipe_profile: 1,
			distributor: 1,
			section: 1,
			section_amount: 1,
			wrg_single_room: 1		
		},
		valveItems:[],
	    device: {
	    	storey: 1,
	    	level: null,
	    	au: 1,
	    	fo: 1,
	    	ewt: 2,
	    	ewt_system: 0,
	    },
		sections:[{
			description: 'Section', 
			pipe_system_type: 1
		}],
	}
};

const state = getDefaultState()

const getters = {

};

const mutations = {
	updateSystemSelection (state, systemSelection) {
	    state.systemSelection = systemSelection
	},
	updateValveItems (state, valveItems) {
	    state.valveItems = valveItems
	},
	updateDevice (state, device) {
	    state.device = device
	},
	updateSections (state, sections) {
	    state.sections = sections
	},
	resetState (state) {
    	Object.assign(state, getDefaultState())
  	}
};

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
};

export default {
  	namespaced: true,
  	state,
  	getters,
  	actions,
  	mutations,
};